import * as React from 'react';
import type { SVGProps } from 'react';
const SvgType01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.968 3h10.064c.439 0 .817 0 1.13.021.33.023.66.072.986.207a3 3 0 0 1 1.624 1.624c.135.326.184.656.207.986.021.313.021.691.021 1.13V7a1 1 0 1 1-2 0c0-.48 0-.79-.017-1.026-.015-.228-.042-.315-.06-.357a1 1 0 0 0-.54-.54c-.042-.018-.129-.045-.357-.06A16.908 16.908 0 0 0 17 5h-4v14h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V5H7c-.48 0-.79 0-1.026.017-.228.015-.315.042-.357.06a1 1 0 0 0-.54.54c-.018.042-.045.129-.06.357C5 6.21 5 6.52 5 7a1 1 0 1 1-2 0v-.032c0-.439 0-.817.021-1.13.023-.33.072-.66.207-.986a3 3 0 0 1 1.624-1.624 3.07 3.07 0 0 1 .986-.207C6.15 3 6.529 3 6.968 3Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgType01.displayName = 'Type01';
export default SvgType01;
